export default "__VITE_ASSET__Bj6uDkFC__"